import { useMutation } from 'react-query';
import { useClient } from '../api/api-client';
import toast from 'react-hot-toast';

const useRetryRefund = function (refetchTransactionDetails) {
  const client = useClient();
  const { mutate: retryRefund } = useMutation({
    mutationKey: ['refund_retry'],
    mutationFn: ({ slug, data }) => {
      client(`${slug}`, { data }).then((res) => {
        if (res.success) {
          toast.success(
            'Refund Initiated, wait few seconds till we are processing the transaction',
          );
          setTimeout(() => {
            refetchTransactionDetails();
          }, 5000);
        } else toast.error('Refund Failed, please contact your POC');
      });
    },
    meta: { hideAlert: true },
  });
  return { retryRefund };
};
export default useRetryRefund;
